export const getStopLoss = (orderSLTP, positionId, digits = 2) => {
  const sltpList = orderSLTP.filter(
    (sltp) => sltp.positionId === positionId && sltp.stopLoss != null
  );
  if (sltpList.length === 0) return null;
  const value = sltpList[0].stopLoss;
  return typeof value === 'number' ? Number(value.toFixed(digits)) : null;
};

export const getTakeProfit = (orderSLTP, positionId, digits = 2) => {
  const sltpList = orderSLTP.filter(
    (sltp) => sltp.positionId === positionId && sltp.takeProfit != null
  );
  if (sltpList.length === 0) return null;
  const value = sltpList[0].takeProfit;
  return typeof value === 'number' ? Number(value.toFixed(digits)) : null;
};

export const calculateCommission = ({ row, symbol, refSymbol, symbolData }) => {
    if (!row || !symbol || !symbolData) return 0;

    const { amount, side } = row;
    const { closeCommissionValue, closeCommissionType, referenceSymbolCalculationType } = symbolData;
    const { bid, ask, contractSize, referenceSymbolId } = symbol;

    if (!bid || !ask) return 0;
    const currentPrice = side === 1 ? bid : ask;

    const calculateRefValue = () => {
        if (!referenceSymbolId || !refSymbol) return 1;
        return referenceSymbolCalculationType === "Division" ? 1 / currentPrice : currentPrice;
    };

    const refValue = calculateRefValue();

    switch (closeCommissionType) {
        case 1:
            return amount * contractSize * currentPrice * 0.01 * closeCommissionValue * refValue;
        case 2:
            return closeCommissionValue * amount;
        case 3:
            return closeCommissionValue;
        default:
            return 0;
    }
};

export const calculateProfitLoss = ({ row, symbol, refSymbol, symbolData }) => {
    if (!row || !symbol || !symbolData) return 0;

    const { amount, side, openPrice, interest = 0 } = row;
    const { closeCommissionType, closeCommissionValue, referenceSymbolCalculationType } = symbolData;
    const { bid, ask, contractSize, referenceSymbolId } = symbol;

    let currentPrice = side === 1 ? bid : ask;
    let profitLoss = 0;

    const calculateCloseCommission = () => {
        switch (closeCommissionType) {
            case 1:
                return amount * contractSize * currentPrice * 0.01 * closeCommissionValue * (calculateRefValue() || 1);
            case 2:
                return closeCommissionValue * amount;
            case 3:
                return closeCommissionValue;
            default:
                return 0;
        }
    };

    const calculateRefValue = () => {
        if (!symbolData) return 1;
        if (!referenceSymbolId || !refSymbol) return 1;
        return referenceSymbolCalculationType === "Division" ? 1 / currentPrice : currentPrice;
    };

    const closeCommission = calculateCloseCommission();

    if (!referenceSymbolId || !refSymbol) {
        profitLoss = side === 1
            ? (currentPrice - openPrice) * contractSize * amount - closeCommission + interest
            : (openPrice - currentPrice) * contractSize * amount - closeCommission + interest;
    } else if (!refSymbol.bid) {
        profitLoss = 0;
    } else {
        const refBid = refSymbol.bid;
        if (side === 1) {
            profitLoss = referenceSymbolCalculationType === 1
                ? ((currentPrice - openPrice) * refBid * contractSize * amount) - closeCommission + interest
                : ((currentPrice - openPrice) / refBid * contractSize * amount) - closeCommission + interest;
        } else {
            profitLoss = referenceSymbolCalculationType === 1
                ? ((openPrice - currentPrice) * refBid * contractSize * amount) - closeCommission + interest
                : ((openPrice - currentPrice) / refBid * contractSize * amount) - closeCommission + interest;
        }
    }

    const parsed = parseFloat(profitLoss);
    return !isFinite(parsed) || Math.abs(parsed) < 0.005 ? "0.00" : parsed.toFixed(2);
};
